import { createAction, props } from '@ngrx/store';

export const toggleNotification = createAction('[NOTIFICATION] TOGGLE_NOTIFICATION', props<{opened: boolean}>());




